exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\np[data-v-65876781] {\n  margin-left: 0.2rem;\n  color: #606266;\n}\n.filename[data-v-65876781] {\n  margin-left: 0.6rem;\n  color: #333;\n}\n[data-v-65876781] .el-row {\n  line-height: 0.46rem;\n}\n[data-v-65876781] .drag-upload {\n  width: 6rem;\n}\n", "", {"version":3,"sources":["G:/work/BJ/广西前端框架/loit-web-component/src/components/EXDialog/EXImportDialog.vue"],"names":[],"mappings":";AAAA;EACE,oBAAoB;EACpB,eAAe;CAAE;AAEnB;EACE,oBAAoB;EACpB,YAAY;CAAE;AAEhB;EACE,qBAAqB;CAAE;AAEzB;EACE,YAAY;CAAE","file":"EXImportDialog.vue","sourcesContent":["p {\n  margin-left: 0.2rem;\n  color: #606266; }\n\n.filename {\n  margin-left: 0.6rem;\n  color: #333; }\n\n/deep/ .el-row {\n  line-height: 0.46rem; }\n\n/deep/ .drag-upload {\n  width: 6rem; }\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?sourceMap!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-65876781","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/EXDialog/EXImportDialog.vue
// module id = 438
// module chunks = 0